"use strict";

/** Converts a mapping of entityTypes to their target node types to the data format requires by the GraphQL Query
 * since GraphQL cannot accept Dictionary types.
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.graphConnectionMappings = void 0;
var lodash_1 = require("lodash");
var graphConnectionMappings = function (set) {
  return (0, lodash_1.map)(set.mappings, function (targetEntityTypeNames, entityTypeName) {
    return {
      targetEntityTypeNames: targetEntityTypeNames,
      entityTypeName: entityTypeName
    };
  });
};
exports.graphConnectionMappings = graphConnectionMappings;